var _Object$getPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of");

var overArg = require('./_overArg');
/** Built-in value references. */


var getPrototype = overArg(_Object$getPrototypeOf, Object);
module.exports = getPrototype;